import { PositiveInt, syntaxFNMA } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.js';

export function extractAge(sale: Element): PositiveInt | undefined {
  try {
    return syntaxFNMA.actualAgeSyntax.decode(extractAdjustmentDescription(sale, 'Age') ?? '').age;
  } catch (e: unknown) {
    console.warn('Failed to parse age', e);
    return undefined;
  }
}
